import { render, staticRenderFns } from "./fikria.vue?vue&type=template&id=02d51bf5&scoped=true"
import script from "./fikria.vue?vue&type=script&lang=js"
export * from "./fikria.vue?vue&type=script&lang=js"
import style0 from "./fikria.vue?vue&type=style&index=0&id=02d51bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d51bf5",
  null
  
)

export default component.exports